define('components/sidemenu/SideMenu', [
    'components/sidemenu/models/SideMenuModel',
    'components/sidemenu/views/SideMenuView'
], function(SideMenuModel, SideMenuView) {

    var _model = {};
    var _view = {};

    return {
        create: function(menuId, options) {
            if (_.isUndefined(_model[menuId])) {
                _model[menuId] = new SideMenuModel(options);
                _view[menuId] = new SideMenuView({ "model": _model[menuId] });
                _view[menuId].render();
            } else {
                console.warn("[SideMenu] Menu already exist : " + menuId);
            }
        },

        remove: function(menuId) {
            _model[menuId] = null;
            _view[menuId] = null;
        },

        open: function(menuId) {
            if (!_.isUndefined(_model[menuId]) && !_model[menuId].get('opened')) {
                _view[menuId].openMenu();
            }
        },

        close: function(menuId, isManual) {
            if (!_.isUndefined(_model[menuId]) && _model[menuId].get('opened')) {
                _view[menuId].closeMenu(isManual);
            }
        },

        toggle: function(menuId, isManual) {
            if (_model[menuId].get('opened')) {
                _view[menuId].closeMenu(isManual);
            } else {
                _view[menuId].openMenu();
            }
        },

        isOpen: function( menuId ) {
            if (!_.isUndefined(_model[menuId])) {
                return _model[menuId].get('opened');
            } else {
                console.warn('[SideMenu -> isOpen] Popin ' + menuId + " does not exist");
                return false;
            }
        }
    };
});
